"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridFilterInternalApi = void 0;
const ApiBase_1 = require("../Implementation/ApiBase");
class GridFilterInternalApi extends ApiBase_1.ApiBase {
    fireGridFilterAppliedEvent() {
        if (this.adaptable.isLive) {
            const currentGridFilter = this.getGridFilterApi().getCurrentGridFilter();
            const adaptableApi = this.getAdaptableApi();
            const gridFilterAppliedInfo = {
                gridFilter: currentGridFilter,
                gridFilterExpressionAST: currentGridFilter
                    ? adaptableApi.expressionApi.getASTForExpression(currentGridFilter === null || currentGridFilter === void 0 ? void 0 : currentGridFilter.Expression)
                    : null,
                adaptableApi: adaptableApi,
                userName: adaptableApi.optionsApi.getUserName(),
                adaptableId: adaptableApi.optionsApi.getAdaptableId(),
            };
            adaptableApi.eventApi.emit('GridFilterApplied', gridFilterAppliedInfo);
        }
    }
}
exports.GridFilterInternalApi = GridFilterInternalApi;
